module.exports = global["jQuery"] = require("-!./jquery.js");